<script>
  import { loadStripe } from '@stripe/stripe-js'
  import { fade } from 'svelte/transition'
  import ajax from '@/scripts/common/ajax.js'
  import { trackGoogleAnalytics } from '@/scripts/common/util.js'
  import Step1Amount from './Step1Amount.svelte'
  import Step2Details from './Step2Details.svelte'
  import Step3Payment from './Step3Payment.svelte'

  let {
    stripePubKey = '',
    endpoint = '',
    successHeadline = '',
    successContent = '',
    sourcePage = '',
    presetAmounts = [],
    initialContact = {},
  } = $props()

  let step = $state(1)
  let selectedPreset = $state(null)
  let amount = $state('')
  let frequency = $state('one-time')
  let amountEditable = $state(false)
  let contact = $state({
    firstName: initialContact.firstName ?? '',
    lastName: initialContact.lastName ?? '',
    email: initialContact.email ?? '',
    phone: initialContact.phone ?? '',
    businessName: initialContact.businessName ?? '',
  })
  let options = $state({
    processingFee: true,
    newsletter: false,
    volunteer: false,
  })
  let stripe = $state(null)
  let clientSecret = $state(null)
  let subscriptionId = $state(null)
  let intentKey = $state('')
  let paymentError = $state(null)

  function next() {
    step += 1
  }

  function back() {
    step -= 1
  }

  function computeIntentKey() {
    return JSON.stringify({
      amount: parseFloat(amount),
      frequency,
      processingFee: options.processingFee,
      email: contact.email,
    })
  }

  async function fetchClientSecret(signal) {
    const reqKey = computeIntentKey()
    clientSecret = null
    subscriptionId = null
    try {
      const data = await ajax
        .post(`${endpoint}/setupintent`, {
          json: { amount: parseFloat(amount), frequency, contact, options, sourcePage },
          signal,
        })
        .json()
      clientSecret = data.clientSecret
      subscriptionId = data.subscriptionId ?? null
      intentKey = reqKey
    } catch (err) {
      if (err.name === 'AbortError' || signal.aborted) return
      paymentError = 'Could not initialize payment. Please try again.'
    }
  }

  async function submitDonation(paymentIntentId) {
    const data = await ajax
      .post(`${endpoint}/submit`, {
        json: {
          amount: parseFloat(amount),
          frequency,
          contact,
          options,
          paymentIntentId,
          subscriptionId,
        },
      })
      .json()
    if (data.ok === true) {
      trackGoogleAnalytics({ event: 'form_submission', form_type: 'Donate Form' })
    }
    return data.ok === true
  }

  $effect(() => {
    if (step === 3 && !stripe && stripePubKey) {
      loadStripe(stripePubKey).then((s) => (stripe = s))
    }
  })

  $effect(() => {
    if (step !== 3) {
      paymentError = null
      return
    }
    const currentKey = computeIntentKey()
    if (intentKey === currentKey) return
    const ac = new AbortController()
    fetchClientSecret(ac.signal)
    return () => ac.abort()
  })
</script>

<form onsubmit={(e) => e.preventDefault()}>
  {#key step}
    <div in:fade={{ duration: 200, delay: 150 }} out:fade={{ duration: 150 }}>
      {#if step === 1}
        <Step1Amount bind:amount bind:selectedPreset bind:frequency {presetAmounts} onnext={next} />
      {:else if step === 2}
        <Step2Details
          bind:amount
          bind:selectedPreset
          bind:amountEditable
          bind:contact
          bind:options
          {frequency}
          onnext={next}
          onback={back}
        />
      {:else if step === 3}
        <Step3Payment
          {stripe}
          {clientSecret}
          bind:paymentError
          {submitDonation}
          {successHeadline}
          {successContent}
          onback={back}
        />
      {/if}
    </div>
  {/key}
</form>
